import type {
  ContactService,
  DispositionService,
  VoiceControlService,
  VoiceService,
} from '@nice-devone/agent-sdk';
import type { CXoneConfiguration, UserInfo } from '@nice-devone/common-sdk';

/**
 * Shared mutable module state for the CXone SDK service.
 * Uses a single object so other modules can mutate fields without import reassignment issues.
 */
export const cxoneSdkState = {
  storedCxoneConfig: null as CXoneConfiguration | null,
  storedUserInfo: null as UserInfo | null,
  pendingInboundContactId: null as string | null,
  preWarmedMediaStream: null as MediaStream | null,
  voiceControlService: null as VoiceControlService | null,
  contactService: null as ContactService | null,
  voiceService: null as VoiceService | null,
  dispositionService: null as DispositionService | null,
};
